export default __webpack_public_path__ + "static/media/iconCopy.d048c240.svg";